import store from "@/state/store";

export default [
    {
        path: '/admin/order-form-items',
        name: 'order_form_items',
        meta: {
            authRequired: true,
        },
        component: () => import('./views/admin/orderFormItemsView.vue'),
    },
    {
        path: '/admin/limits',
        name: 'admin_limits',
        meta: {
            authRequired: true,
        },
        component: () => import('./views/admin/limitsView.vue'),
    },
    {
        path: '/admin/employee-order-forms',
        name: 'admin_employees_order_forms',
        meta: {
            authRequired: true,
        },
        component: () => import('./views/admin/orderFormView.vue'),
    },
    {
        path: '/admin/clients',
        name: 'admin_clients',
        meta: {
            authRequired: true,
        },
        component: () => import('./views/admin/adminClients'),
    },
    {
        path: '/admin/clients/:clientId/campaigns/:campaignId/:tab?',
        name: 'admin_client_profile_campaign',
        meta: {
            authRequired: true,
            async beforeResolve(routeTo, routeFrom, next) {
                if(routeTo.params.tab === 'posts' && store.state.campaign.postsByCampaign[routeTo.params.campaignId] === undefined) {
                    await store.dispatch('campaign/getCampaignPosts', routeTo.params.campaignId);
                }

                return next();
            }
        },
        component: () => import('./views/admin/adminCampaign'),
    },
    {
        path: '/admin/clients/:clientId/:tab?',
        name: 'admin_client_profile',
        meta: {
            authRequired: true,
        },
        component: () => import('./views/admin/adminClient'),
    },
    {
        path: '/admin/influencers',
        name: 'admin_influencers',
        meta: {
            authRequired: true,
        },
        component: () => import('./views/client/clientInfluencers'),
    },
    {
        path: '/admin/influencers/:id',
        name: 'admin_influencer_profile',
        meta: {
            authRequired: true,
        },
        component: () => import('./views/client/clientInfluencerProfile'),
    },
    {
        path: '/admin/influencer-payout',
        name: 'admin_influencer_payout',
        meta: {
            authRequired: true,
            async beforeResolve(routeTo, routeFrom, next) {
                if (!store.getters['admin/hasPayouts']) {
                    await store.dispatch('admin/getPayoutsData');
                }
                next();
            }
        },
        component: () => import('./views/admin/adminInfluencerPayouts'),
    },
    {
        path: '/admin/invoices',
        name: 'admin_client_invoices',
        meta: {
            authRequired: true,
            async beforeResolve(routeTo, routeFrom, next) {
                if (!store.getters['invoices/hasAdminInvoices']) {
                    await store.dispatch('invoices/getAdminInvoicesData');
                }
                next()
            }
        },
        component: () => import('./views/admin/adminInvoices'),
    },
    {
        path: '/admin/employee-budgets',
        name: 'admin_budgets',
        meta: {
            authRequired: true,
        },
        component: () => import('./views/admin/budgetsView.vue'),
    },
    {
        path: '/admin/groups',
        name: 'admin_groups',
        meta: {
            authRequired: true,
        },
        component: () => import('./views/admin/groupsView.vue'),
    },
    {
        path: '/admin/groups/:id/edit',
        name: 'admin_groups_edit',
        meta: {
            authRequired: true,
        },
        component: () => import('./views/admin/groupEditView.vue'),
    },
]
